export interface QuestionResponseModel {
  id: string;
  responseId: string;
  surveyId: string;
  questionId: string;
  responseType: number;
  response: number | null;
}
